.signUpLink {
	margin-top: 24px;
}

.recoverLink {
	margin-top: 18px;
}
